import { render, staticRenderFns } from "./NormalBooking.vue?vue&type=template&id=72d1cedb"
import script from "./NormalBooking.vue?vue&type=script&lang=js"
export * from "./NormalBooking.vue?vue&type=script&lang=js"
import style0 from "./NormalBooking.vue?vue&type=style&index=0&id=72d1cedb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports